import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BottomBorder,
  GroupComparisonContent,
  ReportGroupComparisonCont,
} from './ReportGroupComparison.styles';
import CompareSortFilter from '../../../components/CompareSortFilter/CompareSortFilter';
import GroupComparisonTable from '../../../components/GroupComparisonTable/GroupComparisonTable';
import ReportResultsLegend from '../../../components/ReportResultsLegend/ReportResultsLegend';
import PageSection from '../../../HOC/PageSection/PageSection';

const ReportGroupComparison: FC = () => {
  const { t } = useTranslation();

  return (
    <ReportGroupComparisonCont id="ReportGroupComparisonCont">
      <PageSection title={t('report.groupComparison.groupComparison')}>
        <GroupComparisonContent>
          <BottomBorder>
            <ReportResultsLegend noBorder description={t('report.groupComparison.legendDesc')} />
          </BottomBorder>
          <CompareSortFilter />
          <GroupComparisonTable />
        </GroupComparisonContent>
      </PageSection>
    </ReportGroupComparisonCont>
  );
};

export default ReportGroupComparison;
